module.exports = __webpack_public_path__ + "static/media/7ICJ3.69a4487b.jpg";